import React, {Component} from "react"
import CreateCompanyValueMutation from "@irati/companyvalues/apollo/mutation/Create"
import EditCompanyValueMutation from "@irati/companyvalues/apollo/mutation/Edit"
import {CompanyValue, Trophy} from "@irati/companyvalues/types"
import authentication from "@irati/auth"
import {ApolloState} from "@irati/utils/services/apollo/apolloStateInterface"
import {companyValuesTracking} from "@irati-tracking/admin"

import {CompanyValuesForm} from "./Form"

interface Props {
  onSuccess(): void,
  companyValue: CompanyValue
}

interface State extends Partial<CompanyValue> {}

class CreateCompanyValue extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    const {name = undefined, desc = undefined, tag = undefined, icon = undefined, uuid = undefined} = props.companyValue || {}
    this.state = {
      desc,
      name,
      tag,
      icon,
      uuid
    }
  }

  componentDidMount() {
    if (this.state.uuid) {
      companyValuesTracking.startEditCompanyValue()
    } else {
      companyValuesTracking.startCreateCompanyValue()
    }
  }

  onChangeIcon = (icon: Trophy) => {
    this.setState({icon})
  }

  onChange = (property: string, value: string) => {
    this.setState({[property]: value})
  }

  submit = (onSubmit: any, value: CompanyValue) => {
    const {uuid} = this.state
    if (uuid) {
      companyValuesTracking.editCompanyValue(value, uuid)
    } else {
      companyValuesTracking.createCompanyValue(value)
    }
    onSubmit(value)
  }

  render() {
    const {onSuccess, companyValue} = this.props
    const tenantId = authentication.userTenant().uuid
    const buttonText = companyValue ? "admin.companyValues.edit.button" : "admin.companyValues.create.button"
    const headerText = companyValue ? "admin.companyValues.edit.header" : "admin.companyValues.create.header"
    const MutationComponent = companyValue ? EditCompanyValueMutation : CreateCompanyValueMutation

    return (
      <MutationComponent companyValue={this.state} onCompleted={onSuccess} tenantId={tenantId}>
        {(onSubmit: any, apolloState: ApolloState) => (
          <CompanyValuesForm
            apolloState={apolloState}
            buttonText={buttonText}
            companyValue={this.state}
            headerText={headerText}
            onChange={this.onChange}
            onChangeIcon={this.onChangeIcon}
            onSubmit={(value: State) => this.submit(onSubmit, value)} />
        )}
      </MutationComponent>
    )
  }
}

export default CreateCompanyValue
